export type RewardsProps = React.HTMLAttributes<HTMLDivElement> & {
	pointsEarned: number;
};

export const Rewards: React.FC<RewardsProps> = ({
	pointsEarned: points,
	className,
	...props
}) => (
	<div
		className={`order-rewards${className ? ` ${className}` : ''}`}
		{...props}
	>
		<h3 className="text-secondary">BIGGBY Rewards</h3>

		<p className="mb-0">
			You have {points > 0 && points} point{points !== 1 && 's'}.
		</p>
		{/* <p className="mb-0">
			You have earned {pointsEarned > 0 && pointsEarned} point
			{pointsEarned !== 1 && 's'} on this order and can spend{' '}
			{pointsEarned === 1 ? 'it' : 'them'} the next time you place an
			order in person.
		</p> */}
	</div>
);
